import resources from './resources';

const route = {
	path: ':codeApp/modules',
	name: 'page-module',
	meta: {
		title: 'Módulos',
	},
	component: () => import('@/pages/modules/page-module'),
	props: true,
	children: [
		{
			path: 'new',
			name: 'page-module-new',
			meta: {
				title: 'Nuevo Módulo',
			},
			component: () => import('@/pages/modules/page-module-new'),
			props: true,
		},
		{
			path: ':id/edit',
			name: 'page-module-edit',
			meta: {
				title: 'Editar Módulo',
			},
			component: () => import('@/pages/modules/page-module-new'),
			props: true,
		},
		resources,
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/modules.js